const AdminSurveyManagement = () => {
    return(
        <> 
        survey management
        </>
    )
};
export default AdminSurveyManagement;